export default __webpack_public_path__ + "static/vprs-vp1-dc6a1de61c74552c97a59afa395d29f6.png";